exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icon-ym[data-v-4e6f274c] {\r\n  font-size: 20px;\r\n  color: #666666;\n}\r\n", ""]);

// exports
